import { Labeled, NumberField } from 'ra-ui-materialui'
import React, { useMemo } from 'react'
import { TransactionCustomization } from 'services/api/entities/accounting/transaction/types/internal/transaction-models'
import { CountryCode } from 'services/cfg/countries'
import { getCountry } from 'services/geo-management'
import {
  CustomRecordForAggregates,
  buildUseAggregateComputedRecord,
} from './computedGetters'
import { roundTwoDecimals } from './TransactionForm'

type Props = {
  aggregateRecord: CustomRecordForAggregates[]
  formId: number
  discountPerc: number
  customizations: TransactionCustomization[]
  customerBusinessCountry?: CountryCode
}

const useAggregateComputedRecord = buildUseAggregateComputedRecord(
  useMemo,
  getCountry().code
)

const FormGeneralSection: React.FC<Props> = ({
  aggregateRecord,
  formId,
  discountPerc,
  customerBusinessCountry,
  customizations,
}) => {
  const totalPricesRecord = useAggregateComputedRecord(
    aggregateRecord,
    customizations,
    discountPerc,
    customerBusinessCountry
  )

  return (
    <>
      {Object.keys(totalPricesRecord).map((item, idx) => (
        <Labeled
          key={idx}
          label={`form.fields.${item}`}
          style={{ marginBottom: '16px' }}
        >
          <NumberField
            record={{ ...totalPricesRecord, id: formId }}
            source={`${item}`}
            options={roundTwoDecimals}
          />
        </Labeled>
      ))}
    </>
  )
}

export default FormGeneralSection
